import { inventoryInstance } from 'services/api';

/**
 * The Inventory Management section talks to the orders.co-inventory backend
 * through a dedicated axios instance. The instance already attaches the api01
 * bearer token, the `business` header, and a `businessUuid` query param scoped
 * to the active business (see services/api.js).
 */
const client = inventoryInstance;

/** Extracts a human-readable message from an inventory backend error. */
export const getErrorMessage = (error) => {
  const data = error?.response?.data;
  if (data?.message) {
    return Array.isArray(data.message) ? data.message.join('\n') : data.message;
  }
  return error?.message || 'Something went wrong';
};

export default client;
